import React from 'react';
import { submitLogin } from '../../actions/authActions';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import logoWhite from '../../images/logo-white.png';
import './LoginRedesign.css';

function Login(props) {
  const [details, setDetails] = React.useState({
    email: '',
    password: '',
  });
  const [showPassword, setShowPassword] = React.useState(false);
  const [socialError, setSocialError] = React.useState('');

  React.useEffect(() => {
    if (props.loggedIn) {
      props.history.push('/main');
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const social = params.get('social');
    const token = params.get('token');
    const email = params.get('email');
    const message = params.get('message');

    if (social === 'success' && token && email) {
      localStorage.setItem('token', token);
      localStorage.setItem('email', email);
      window.location.assign('/dashboard');
      return;
    }

    if (social === 'error') {
      setSocialError(message || 'Social sign in failed. Please try again.');
    }
  }, [props.loggedIn, props.history]);

  const updateDetails = event => {
    const { id, value } = event.target;
    setDetails(prev => ({
      ...prev,
      [id]: value,
    }));
  };

  const login = event => {
    event.preventDefault();

    if (details.email && details.password) {
      props.login(details);
    }
  };

  const startSocialLogin = provider => {
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    if (!backendUrl) {
      setSocialError('Social sign in is unavailable because backend URL is not configured.');
      return;
    }

    window.location.assign(`${backendUrl}/user/oauth/${provider}?redirect=login`);
  };

  return (
    <div className="login-redesign">
      <div className="login-shell">
        <div className="login-brand-panel">
          <a className="login-logo" href="/" aria-label="EditPage home">
            <img src={logoWhite} alt="EditPage" />
          </a>

          <div>
            <div className="login-brand-copy">
              <div className="login-eyebrow">Workspace pulse</div>
              <h1>Your latest launches are waiting.</h1>
              <p>Jump back into edits, review performance, and publish updates in seconds.</p>
            </div>

            <div className="login-site-list">
              <div className="login-site-row">
                <div className="login-site-thumb" />
                <div className="login-site-info">
                  <h5>Riverline Studio</h5>
                  <p>Homepage published 16 minutes ago</p>
                </div>
                <span className="login-site-status live">Live</span>
              </div>
              <div className="login-site-row">
                <div className="login-site-thumb" />
                <div className="login-site-info">
                  <h5>southmarketco.com</h5>
                  <p>2 new orders in checkout</p>
                </div>
                <span className="login-site-status live">Active</span>
              </div>
              <div className="login-site-row">
                <div className="login-site-thumb" />
                <div className="login-site-info">
                  <h5>new-product-drop</h5>
                  <p>Ready to publish, draft saved</p>
                </div>
                <span className="login-site-status draft">Draft</span>
              </div>
            </div>
          </div>

          <div className="login-panel-footer">© {new Date().getFullYear()} EditPage.com</div>
        </div>

        <div className="login-form-panel">
          <div className="login-form-wrap">
            <div className="login-form-head">
              <h2>Log in to your account</h2>
              <p>Access your EditPage account.</p>
            </div>

            <div className="login-oauth-row">
              <button type="button" className="login-oauth-btn" onClick={() => startSocialLogin('google')}>
                <svg viewBox="0 0 24 24"><path fill="#4285F4" d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.5h6.5c-.3 1.5-1.1 2.7-2.4 3.6v3h3.9c2.3-2.1 3.5-5.2 3.5-8.8z" /><path fill="#34A853" d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.9-3c-1.1.7-2.4 1.2-4 1.2-3.1 0-5.7-2.1-6.6-4.9H1.4v3.1C3.4 21.3 7.4 24 12 24z" /><path fill="#FBBC05" d="M5.4 14.4c-.2-.7-.4-1.5-.4-2.4s.1-1.6.4-2.4V6.5H1.4C.5 8.2 0 10.1 0 12s.5 3.8 1.4 5.5l4-3.1z" /><path fill="#EA4335" d="M12 4.8c1.8 0 3.3.6 4.6 1.8l3.4-3.4C17.9 1.2 15.2 0 12 0 7.4 0 3.4 2.7 1.4 6.5l4 3.1c.9-2.8 3.5-4.8 6.6-4.8z" /></svg>
                Google
              </button>
              <button type="button" className="login-oauth-btn" onClick={() => startSocialLogin('apple')}>
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M16.365 1.43c0 1.14-.493 2.27-1.177 3.08-.744.9-2.02 1.6-3.145 1.51-.11-1.14.44-2.31 1.14-3.09.75-.86 2.08-1.5 3.18-1.5zm3.62 17.14c-.28.65-.62 1.28-1.02 1.87-.55.82-1 1.39-1.35 1.71-.55.5-1.14.75-1.77.77-.46.01-1.01-.13-1.65-.42-.64-.29-1.23-.43-1.77-.43-.56 0-1.16.14-1.81.43-.65.29-1.17.44-1.58.45-.6.03-1.2-.23-1.79-.79-.38-.35-.86-.94-1.43-1.79-.61-.9-1.11-1.95-1.51-3.14-.43-1.28-.64-2.52-.64-3.72 0-1.37.3-2.56.89-3.55.47-.79 1.09-1.42 1.87-1.88.78-.46 1.62-.7 2.53-.71.49 0 1.15.16 1.98.47.83.31 1.36.47 1.6.47.18 0 .77-.18 1.77-.55.94-.34 1.74-.48 2.39-.43 1.77.14 3.1.84 3.99 2.1-1.58.96-2.36 2.3-2.35 4.03.01 1.35.5 2.47 1.47 3.36.44.42.93.74 1.48.97-.12.35-.25.68-.39 1z" /></svg>
                Apple
              </button>
            </div>

            {socialError ? <div className="login-error">{socialError}</div> : null}
            {props.authError ? <div className="login-error">{props.authErrorMessage}</div> : null}

            <div className="login-divider">or with email</div>

            <form onSubmit={login}>
              <div className="login-field">
                <label htmlFor="email">Email address</label>
                <div className="login-input-wrap">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="4" width="20" height="16" rx="2" /><path d="M22 6l-10 7L2 6" /></svg>
                  <input
                    type="email"
                    id="email"
                    autoComplete="email"
                    placeholder="you@example.com"
                    value={details.email}
                    onChange={updateDetails}
                    required
                  />
                </div>
              </div>

              <div className="login-field">
                <div className="login-field-top">
                  <label htmlFor="password">Password</label>
                  <a href="/forgotpassword" className="forgot-link">Forgot password?</a>
                </div>
                <div className="login-input-wrap">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="10" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    autoComplete="current-password"
                    placeholder="Enter password"
                    value={details.password}
                    onChange={updateDetails}
                    required
                  />
                  <button
                    type="button"
                    className="login-pw-toggle"
                    onClick={() => setShowPassword(prev => !prev)}
                  >
                    {showPassword ? 'Hide' : 'Show'}
                  </button>
                </div>
              </div>

              <div className="login-remember-row">
                <input type="checkbox" id="remember" />
                <label htmlFor="remember">Keep me logged in on this device</label>
              </div>

              <button type="submit" className="login-submit-btn">Log in</button>
            </form>

            <div className="login-divider" />

            <div className="login-signup-row">Need an account? <a href="/signup">Create one</a></div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    loggedIn: state.auth.loggedIn,
    currentUser: state.auth.currentUser,
    authError: state.auth.authError,
    authErrorMessage: state.auth.authErrorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    login: (data) => {
      dispatch(submitLogin(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));
